import { Divider, MenuItem } from '@mui/material';
import { Text } from '../../Text';
import { ElementType, ReactNode } from 'react';

export interface AccountLinkType {
  url: string;
  highlighted?: boolean;
  hideDivider?: boolean;
}
export type AccountMenuSurface = 'page' | 'popover';

interface AccountMenuLinkProps {
  label: string;
  autoFocus?: boolean;
  link: AccountLinkType;
  onClick: () => void;
  children?: ReactNode;
  linkComponent: ElementType;
  surface?: AccountMenuSurface;
}

export const AccountMenuLink = (props: AccountMenuLinkProps) => {
  const { label, link, onClick, children, linkComponent, autoFocus, surface = 'popover' } = props;
  return (
    <>
      <MenuItem
        component={linkComponent}
        to={link.url}
        onClick={onClick}
        sx={(theme) => ({
          paddingX: 2,
          paddingY: 1,
          backgroundColor:
            surface === 'page' ? theme.palette.background.default : theme.palette.background.paper,
        })}
        autoFocus={autoFocus}
        tabIndex={0}
        selected={link.highlighted}
        role="menuitem"
      >
        <Text variant="p2" fontWeight={link.highlighted ? 'bold' : 'normal'}>
          {label}
        </Text>
        {children}
      </MenuItem>
      {!link.hideDivider && <Divider color="lightGray" sx={{ marginX: 2 }} role="separator" />}
    </>
  );
};
